<template>
  <transition
    name="fade"
  >
    <div
      v-if="open"
      :class="[
        `tooltip`,
        `tooltip--${level}`
      ]"
    >
      <div class="tooltip__close">
        <module-icon
          v-if="close"
          icon="close"
          @click.native="closeTooltip()"
        />
      </div>
      <div class="tooltip__wrapper">
        <module-icon
          v-if="tipIcon"
          :icon="tipIcon"
        />
        <div :class="[tipIcon ? 'ml' : '']">
          <slot name="message"/>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>

// Modules
import ModuleLink from 'modules/Link';
import ModuleIcon from 'modules/Icon';

// Export
export default {
  name: `ui-tooltip`,

  components: {
    ModuleLink,
    ModuleIcon,
  },

  // Props
  props: {
    heading: String,
    close: Boolean,
    level: String,
    tipIcon: String,
  },

  // Data
  data() {
    return {
      open: true,
    };
  },

  // Methods
  methods: {
    closeTooltip() {
      this.open = false;
    },
  },
};
</script>



// WEBPACK FOOTER //
// Tooltip.vue?bc1ce62a